<template>
  <div class="bg-picker w-full px-24 py-48 mb-24">
    <h1 class="text-center asH3 mb-24">Skaffa stilen</h1>

    <div class="flex flex-wrap justify-center">
      <TabSelector
        text="Alla stilar"
        :selected="selectedCategoryId === ''"
        class="mb-12 mx-4"
        @click="$emit('setCategory', '' + '')"
      />
      <div
        v-for="category in categories"
        :key="category.id"
      >
        <TabSelector
          v-if="category.count > 0"
          :text="category.name"
          :selected="selectedCategoryId === category.id"
          class="mb-12 mx-4"
          @click="$emit('setCategory', category.id)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TabSelector from '~/components/generic/TabSelector.vue';
export default defineComponent({
  name: 'ListCategories',
  components: { TabSelector },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    selectedCategoryId: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped lang="postcss"></style>
